<template>
  <div
    class="fixed z-50 bottom-20 text-dark-600 bg-white hover:bg-grey-50 rounded-10 py-10 px-19
           flex items-center cursor-pointer anim-color"
    :class="[position, {'shadow-badge border border-grey-700': !isDarkMode } ]"
    @click="upgrade"
  >
    <div class="flex items-center mr-5">
      <img :src="require(`@/assets/images/thunder.svg`)" alt="" class="w-16 h-16 mr-5">
      <p class="font-medium text-14">Upgrade to PRO</p>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

export default defineComponent({
  setup () {
    const { state, getters } = useStore()
    const route = useRoute()

    const showSidebar = computed(() => state.settings.showSidebar)
    const isMobile = computed(() => getters.isMobile)
    const isDarkMode = computed(() => getters.isDarkMode)

    const isToolPage = computed(() => ['TaskBoard', 'WeekPlanner'].includes(route.name))

    const position = computed(() => {
      if (isMobile.value) {
        return showSidebar.value
          ? '-right-350'
          : isToolPage.value ? 'left-20' : 'right-20'
      }
      return 'right-20'
    })

    const user = computed(() => state.profile.user)

    function upgrade () {
      window.open(`https://helloivy.co/upgrade?userId=${user.value.id}`, '_blank')
    }

    return {
      position,
      isDarkMode,
      upgrade
    }
  }
})
</script>
